import BaseImportModal from "@/components/reusables/BaseImportModal";
import { useGetImportableColumnsQuery } from "@redux/features/dfs/dfsApi";
import { performImport } from "@redux/features/dfs/thunks";
import { useImportProductDraftsMutation } from "@redux/features/productDrafts/productDraftsApi";
import { useAppDispatch } from "@redux/hooks";
import { useTranslation } from "react-i18next";

interface ProductDraftsImportModalProperties {
    isOpen?: boolean;
    onClose?: () => void;
}

export default function ProductDraftsImportModal(props: ProductDraftsImportModalProperties) {
    const { t } = useTranslation("", { keyPrefix: "imports.modules.product_draft.importModal" });

    const dispatch = useAppDispatch();
    const [importProductDrafts, { isLoading: isImportLoading }] = useImportProductDraftsMutation();

    const { data: columns = [], isLoading: isColumnsLoading } = useGetImportableColumnsQuery({
        module: "product_draft",
    });

    const tips = [t("tips.location")];

    return (
        <>
            <BaseImportModal
                optionsList={columns}
                tips={tips}
                isOpen={props.isOpen}
                onClose={props.onClose}
                isLoading={isImportLoading || isColumnsLoading}
                onImport={(formData) => {
                    const operation = dispatch(
                        performImport("product_draft", () => importProductDrafts(formData).unwrap())
                    ) as unknown as Promise<unknown>;

                    // performImport already reports and logs an immediate API failure.
                    void operation.catch(() => undefined);
                }}
            />
        </>
    );
}
